import { createTestIds } from '../../utils';

export const getMetaListTestIds = createTestIds('meta-list', [] as const);
